var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClothesSub(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 38,
    viewBox: "0 0 109 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.66 0H109v38H.66z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.72 19.092s1.157-8.438 1.537-11.245c.186-1.393 1.15-2.557 2.557-2.557h.697c1.406 0 2.302 1.176 2.557 2.557.517 2.776 2.048 11.245 2.048 11.245"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.72 19.092s1.157-8.438 1.537-11.245c.186-1.393 1.15-2.557 2.557-2.557h.697c1.406 0 2.302 1.176 2.557 2.557.517 2.776 2.048 11.245 2.048 11.245",
    stroke: "currentColor",
    strokeWidth: 0.809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.857 31.307H8.984a.511.511 0 01-.51-.51L6.937 16.36a.516.516 0 01.51-.516h21.941a.517.517 0 01.51.516l-1.53 14.437a.51.51 0 01-.51.51zM7.97 26.976h20.69",
    stroke: "currentColor",
    strokeWidth: 0.809,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.643 17.443L33.57 20l-4.91 6.976M7.012 17.443L3.085 20l4.91 6.976",
    stroke: "currentColor",
    strokeWidth: 0.809,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.19 16.449l1.178-11.435-.958-.971h-.04a6.093 6.093 0 01-2.011 1.407 6.053 6.053 0 01-6.81-1.407h-.04l-.957.971s1.177 11.394 1.17 11.435l-9.312 16.28c.971.355 5.987 1.963 13.543 1.963 7.23 0 12.638-1.508 13.543-1.963l-9.306-16.28z",
    stroke: "currentColor",
    strokeWidth: 0.809,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.576 26.934h8.553v8.197h-8.553z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.722 8.315L57.706 4.48l-4.115.063-4.612-.063-5.736 3.827a1.839 1.839 0 00-.808 1.263l-1.65 10.455-1.348 14.09 3.272.302 1.797-14.231 1.882-8.355c.54 2.567.796 5.185.765 7.807 0 3.469-1.404 10.532-1.404 10.532a.702.702 0 00.702.702l7.14 1.938 7.14-1.938a.702.702 0 00.703-.702s-1.404-7.063-1.404-10.532a42.194 42.194 0 01.702-7.807l1.734 8.355 1.79 14.231 3.272-.302-1.334-13.957-1.657-10.531a1.847 1.847 0 00-.815-1.313z",
    stroke: "currentColor",
    strokeWidth: 0.809,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.978 4.481l4.515 8.257 4.212-8.257M53.339 12.738l.252 20.073",
    stroke: "currentColor",
    strokeWidth: 0.809,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.603 26.934h8.553v8.91h-8.553z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.097 8.637c-6.264 10.63-8.207 24.604-8.207 24.604a56.698 56.698 0 0029.038 0S89.09 18.099 82.721 8.637"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.097 8.637c-6.264 10.63-8.207 24.604-8.207 24.604a56.698 56.698 0 0029.038 0S89.09 18.099 82.721 8.637M82.721 4.481H70.097v4.156H82.72V4.481z",
    stroke: "currentColor",
    strokeWidth: 0.809,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7 29.085a50.21 50.21 0 0013.757 1.69c4.667.058 9.32-.528 13.827-1.742",
    stroke: "currentColor",
    strokeWidth: 0.809,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.414 8.637v7.432M79.898 8.637l1.743 5.69M72.92 8.637l-1.743 5.69",
    stroke: "currentColor",
    strokeWidth: 0.809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.319 26.934h8.553v8.91h-8.553z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.58 3.234l2.672 1.247.535.267 2.138-1.514 2.317.713v2.316l-.891 3.564.89 3.03 3.565 5.524 2.495 5.88 1.247 5.703v3.207l-.356 1.426-1.604.89-1.426-.356-1.425-1.96-.357 1.07-1.069.89-1.07.357-1.425-.891-.89-1.426-.535 1.07-1.604 1.247-1.604-.357-1.604-1.96-.89 1.96-1.604.357-1.07-.357-1.058-1.96-.367 1.07-1.247 1.247-2.139-.357-.712-1.425v-3.03l.712-4.098 1.07-3.564 1.781-4.099 2.673-4.276 1.604-3.742V8.223l-.713-3.03V3.947l1.96-.713z",
    stroke: "currentColor",
    strokeWidth: 0.317
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.425 4.636c-.806-.55-2.761-1.546-4.13-1.121-.314.118-.896.66-.707 1.888l.472 2.123c.393 1.023.908 3.434-.178 4.897-1.061 1.593-3.386 5.167-4.188 6.725-.983 1.966-2.863 6.985-3.382 11.563-.059.294-.177 1.356-.177 2.36M85.973 32.952a2.419 2.419 0 11-4.838 0",
    stroke: "currentColor",
    strokeWidth: 0.809,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.81 32.952a2.419 2.419 0 11-4.837 0",
    stroke: "currentColor",
    strokeWidth: 0.809
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.229 35.371a2.419 2.419 0 01-2.419-2.419M93.405 4.636c.807-.55 2.761-1.546 4.13-1.121.315.118.897.66.708 1.888l-.472 2.123c-.393 1.023-.909 3.434.177 4.897 1.062 1.593 3.386 5.167 4.188 6.725.984 1.966 2.863 6.985 3.382 11.563.059.294.177 1.356.177 2.36",
    stroke: "currentColor",
    strokeWidth: 0.809,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.858 32.952a2.419 2.419 0 104.837 0",
    stroke: "currentColor",
    strokeWidth: 0.809
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.453 32.952a.404.404 0 01.809 0h-.809zm-4.433 0h.404c0 1.113.902 2.015 2.015 2.015v.808a2.823 2.823 0 01-2.823-2.823h.404zm2.419 2.419v-.404a2.014 2.014 0 002.014-2.015h.809a2.823 2.823 0 01-2.823 2.823v-.404z",
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M93.602 35.371a2.419 2.419 0 002.418-2.419M89.596 11.32c.898-.198 2.56.057 3.638 2.425M97.277 11.377c-.899-.197-2.965 0-4.043 2.368M90.404 11.723l-4.042 14.554M91.95 12.128l-.737 10.51M96.274 11.723l4.043 14.15M94.728 12.128l.738 10.51M27.745 16.17c1.617.7 5.578 1.68 8.489 0",
    stroke: "currentColor",
    strokeWidth: 0.809,
    strokeLinecap: "round"
  })));
}
export default SvgClothesSub;